<template>
    <div class="card text-white" style="margin-bottom: 10px;">
        <div class="card-body">
            <div class="row">
                <div class="col-12 ">

                    <h4 style="background: #0078be!important;"
                        class="text-center card-title bg-primary text-white w-100 p-1">
                        CARGAR INVENTARIO
                    </h4>

                    <!-- Input para subir archivo Excel -->
                    <div class="mb-4">
                        <div class="form-group" v-if="userRole === 'administrador' || userRole === 'bodega'">
                            <label for="excelFile" class="form-label">Seleccionar archivo Excel:</label>
                            <input type="file" id="excelFile" class="form-control" accept=".xlsx,.xls"
                                @change="handleFileUpload" :disabled="loading"  />
                        </div>
                        <div v-if="loading" class="mt-2">

                            <span class="ms-2">Procesando archivo...</span>
                        </div>
                    </div>

                    <!-- Botones para procesar y subir a la nube -->
                    <div class="mb-3" v-if="selectedFile && !loading">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <button @click="processExcelFile" class="btn btn-primary w-100" :disabled="loading">
                                    <i class="fas fa-upload me-2"></i>Procesar Inventario
                                </button>
                            </div>
                                                          <div class="col-md-6 mb-2">
                                  <button @click="uploadToCloud" class="btn btn-success w-100"
                                      :disabled="loading || transactions.length === 0"
                                      v-if="userRole === 'administrador' || userRole === 'bodega'">
                                      <i class="fas fa-cloud-upload-alt me-2"></i>Subir a la Nube
                                  </button>
                            </div>
                        </div>
                    </div>




                </div>

                <div class="col-12 col-md-8">
                    <!-- DataTable para mostrar los datos -->
                    <div v-if="transactions.length > 0 && !loading" class="mt-4">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h5 class="text-center mb-0">INVENTARIO CARGADO</h5>
                            <button @click="loadProductos" class="btn btn-outline-primary btn-sm" :disabled="loading">
                                <i class="fas fa-sync-alt me-1"></i>Actualizar
                            </button>
                        </div>
                        <DataTable :columns="columns" :options="options" :data="transactions" class="table tablesorter"
                            width="100%">
                            <thead>
                                <tr>
                                    <th style="width: 8%">#</th>
                                    <th data-priority="1" style="width: 45%">NOMBRE</th>
                                    <th style="text-align: center; width: 15%">CANTIDAD</th>
                                </tr>
                            </thead>
                        </DataTable>
                    </div>
                </div>

                <div class="col-12 col-md-4">
                    <div v-if="transactions.length > 0 && !loading" class="mt-4">
                        <h5 class="text-center mb-3">INFORMACIÓN DEL INVENTARIO</h5>

                        <!-- Estadísticas principales -->
                        <div class="stats-container mb-4">
                            <div class="stat-card primary">
                                <div class="stat-icon">
                                    <i class="fas fa-boxes"></i>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-number">{{ responseData?.datos?.total_productos || 0 }}</div>
                                    <div class="stat-label">Total Productos</div>
                                </div>
                            </div>

                            <div class="stat-card secondary">
                                <div class="stat-icon">
                                    <i class="fas fa-clock"></i>
                                </div>
                                <div class="stat-content">
                                    <div class="stat-number">{{ responseData?.datos?.fechas_insert?.length || 0 }}</div>
                                    <div class="stat-label">Total de Subidas</div>
                                </div>
                            </div>
                        </div>

                        <!-- Última actualización -->
                        <div class="update-info mb-4">
                            <div class="update-header">
                                <i class="fas fa-sync-alt me-2"></i>
                                <strong>Última Actualización</strong>
                            </div>
                            <div class="update-time">
                                {{ responseData?.datos?.ultima_actualizacion || 'N/A' }}
                            </div>
                        </div>

                        <!-- Timeline de fechas -->
                        <div class="timeline-container">
                            <div class="timeline-header">
                                <i class="fas fa-history me-2"></i>
                                <strong>Historial de Subidas</strong>
                            </div>

                            <div v-if="responseData?.datos?.fechas_insert && responseData.datos.fechas_insert.length > 0"
                                class="timeline">
                                <div v-for="(fecha, index) in responseData.datos.fechas_insert" :key="fecha.Id"
                                    class="timeline-item" @click="showFechaDetails(fecha, index)">

                                    <div class="timeline-marker">
                                        <div class="marker-dot"></div>
                                        <div class="marker-line"
                                            v-if="index < responseData.datos.fechas_insert.length - 1"></div>
                                    </div>

                                    <div class="timeline-content">
                                        <div class="timeline-date">
                                            {{ formatFecha(fecha.fecha_ingreso) }}
                                        </div>
                                        <div class="timeline-time">
                                            <i class="fas fa-clock me-1"></i>
                                            {{ getTimeFromFecha(fecha.fecha_ingreso) }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else class="empty-timeline">
                                <i class="fas fa-calendar-times"></i>
                                <p>No hay fechas de subida registradas</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Indicador de carga -->
                <div v-if="loading" class="col-12 mt-4">
                    <div class="loading-container text-center">
                        <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                            <span class="visually-hidden">Cargando...</span>
                        </div>
                        <div class="mt-3">
                            <h5 class="text-primary">Actualizando Inventario</h5>
                            <p class="text-muted">Por favor espera mientras se cargan los datos...</p>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    </div>
</template>

<script>
/* eslint-disable */
import readXlsxFile from "read-excel-file";
import DataTable from 'datatables.net-vue3'
import DataTablesCore from 'datatables.net-bs5';
import 'datatables.net-responsive';

DataTable.use(DataTablesCore);

export default {
    name: "InventarioComponent",
    props: {
    },
    components: {
        DataTable
    },
    data() {
        return {
            loading: false,
            isMobile: this.$isMobile,
            transactions: [],
            items: [],
            selectedFile: null,
            responseData: null,
            columns: [
                {
                    data: null,
                    render: function (data, type, row, meta) {
                        const index = meta.row + 1;
                        return index;
                    }
                },
                { data: 'NOMBRE' },
                { data: 'CANTIDAD', className: 'text-center' }
            ],
            options: {
                responsive: true,
                "ordering": false,
                columnDefs: [
                    { responsivePriority: 1, targets: 0 },
                    { responsivePriority: 2, targets: -1 }
                ],
                lengthMenu: [
                    [5, 15, 25, 35, 50, -1],
                    [5, 15, 25, 35, 50, "All"],
                ],
                pageLength: 15,
                "language": {
                    "search": "Buscar:",
                    "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
                    "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
                    "searchPlaceholder": "Ingrese algún dato",
                    "zeroRecords": "Lo sentimos, no se encontraron resultados",
                    "processing": "Buscando. Espere por favor...",
                    "sLengthMenu": "Mostrar _MENU_ registros",
                    "oPaginate": {
                        "sFirst": "Primero",
                        "sLast": "Último",
                        "sNext": "Siguiente",
                        "sPrevious": "Anterior"
                    },

                }
            },

        };
    },
    methods: {
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                this.selectedFile = file;
                this.transactions = []; // Limpiar datos anteriores
                this.showInfoToast('Archivo seleccionado. Haz clic en "Procesar Inventario" para continuar.');
            }
        },

        async processExcelFile() {
            if (!this.selectedFile) {
                this.showErrorToast('Por favor selecciona un archivo primero.');
                return;
            }

            this.loading = true;
            this.items = [];
            this.transactions = [];

            try {
                const rows = await readXlsxFile(this.selectedFile);

                if (rows.length < 6) {
                    this.showErrorToast('El archivo no contiene suficientes datos. Se requieren al menos 6 filas.');
                    return;
                }

                // Procesar desde la fila 6 (índice 5) según especificaciones
                // B6 = columna 1 (índice 1), D6 = columna 3 (índice 3)
                for (let i = 5; i < rows.length; i++) {
                    const row = rows[i];

                    // Verificar que las celdas no estén vacías
                    if (row && row[1] && row[3]) {
                        this.items.push({
                            NOMBRE: String(row[1]).trim(), // B6 (columna 1)
                            CANTIDAD: parseInt(row[3]) || 0 // D6 (columna 3)
                        });
                    }
                }

                this.transactions = this.items;

                console.log(this.transactions)

                if (this.transactions.length > 0) {
                    this.showSuccessToast(`Datos cargados exitosamente. ${this.transactions.length} productos procesados.`);
                } else {
                    this.showWarningToast('No se encontraron datos válidos en el archivo.');
                }

            } catch (error) {
                console.error('Error procesando archivo:', error);
                this.showErrorToast('Ocurrió un error al procesar el archivo. Verifica que sea un archivo Excel válido.');
            } finally {
                this.loading = false;
            }
        },

        showSuccessToast(message) {
            // Implementar según tu sistema de notificaciones
            if (this.$toast) {
                this.$toast.success(message);
            } else {
                alert('Éxito: ' + message);
            }
        },

        showErrorToast(message) {
            // Implementar según tu sistema de notificaciones
            if (this.$toast) {
                this.$toast.error(message);
            } else {
                alert('Error: ' + message);
            }
        },

        showWarningToast(message) {
            // Implementar según tu sistema de notificaciones
            if (this.$toast) {
                this.$toast.warning(message);
            } else {
                alert('Advertencia: ' + message);
            }
        },

        showInfoToast(message) {
            // Implementar según tu sistema de notificaciones
            if (this.$toast) {
                this.$toast.info(message);
            } else {
                alert('Info: ' + message);
            }
        },

        async uploadToCloud() {
            if (this.transactions.length === 0) {
                this.showErrorToast('No hay datos para subir a la nube. Procesa un archivo primero.');
                return;
            }

            this.loading = true;

            try {
                const payload = {
                    inventario: this.transactions,
                    totalProductos: this.transactions.length
                };

                const response = await this.$https.post('/evaluacion/getInsertInventario', payload, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                });

                if (response.data.code === 200) {
                    this.showSuccessToast(`Inventario subido exitosamente a la nube. ${this.transactions.length} productos guardados.`);
                    this.loadProductos()
                } else {
                    this.showErrorToast(`Error en el servidor: ${response.data.message || 'Código de respuesta inesperado'}`);
                }

            } catch (error) {
                console.error('Error subiendo a la nube:', error);

                if (error.response) {
                    this.showErrorToast(`Error del servidor: ${error.response.data?.message || error.response.statusText}`);
                } else if (error.request) {
                    this.showErrorToast('Error de conexión. Verifica tu conexión a internet.');
                } else {
                    this.showErrorToast('Error al subir el inventario a la nube. Intenta nuevamente.');
                }
            } finally {
                this.loading = false;
            }
        },

        async loadProductos() {
            this.loading = true;

            try {
                const response = await this.$https.post('/evaluacion/getLoadInventario', {}, {
                    headers: {
                        "Content-Type": "application/json"
                    }
                });

                if (response.data.code === 200) {

                    // Guardar la respuesta completa para mostrar información adicional
                    this.responseData = response.data;

                    // Transformar los datos para que coincidan con el formato del DataTable
                    const inventario = response.data.datos.inventario;
                    this.transactions = inventario.map(item => ({
                        NOMBRE: item.nombre,
                        CANTIDAD: item.cantidad
                    }));


                    if (this.transactions.length > 0) {
                        this.showSuccessToast(`Inventario cargado: ${this.transactions.length} productos encontrados`);
                    } else {
                        this.showInfoToast('No hay productos en el inventario');
                    }
                } else if (response.data.code === 204) {
                    console.log('No hay productos en el inventario:', response.data);

                    // Limpiar los datos y mostrar mensaje
                    this.transactions = [];
                    this.responseData = response.data;
                    this.showInfoToast('No hay productos en el inventario');
                } else {
                    this.showErrorToast(`Error en el servidor: ${response.data.message || 'Código de respuesta inesperado'}`);
                }




            } catch (error) {
                console.error('Error loadProductos:', error);

                if (error.response) {
                    this.showErrorToast(`Error del servidor: ${error.response.data?.message || error.response.statusText}`);
                } else if (error.request) {
                    this.showErrorToast('Error de conexión. Verifica tu conexión a internet.');
                } else {
                    this.showErrorToast('Error al cargar el inventario. Intenta nuevamente.');
                }
            } finally {
                this.loading = false;
            }
        },

        formatFecha(fechaString) {
            if (!fechaString) return 'N/A';
            const fecha = new Date(fechaString);
            return fecha.toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        },

        getTimeFromFecha(fechaString) {
            if (!fechaString) return 'N/A';
            const fecha = new Date(fechaString);
            return fecha.toLocaleTimeString('es-ES', {
                hour: '2-digit',
                minute: '2-digit'
            });
        },

        showFechaDetails(fecha, index) {
            const fechaFormateada = this.formatFecha(fecha.fecha_ingreso);
            const horaFormateada = this.getTimeFromFecha(fecha.fecha_ingreso);

            this.showInfoToast(`Subida #${index + 1}: ${fechaFormateada} a las ${horaFormateada}`);
        }

    },
    mounted() {
        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }


        this.loadProductos()

    },
    computed: {
        userRole() {
            const encryptedRole = localStorage.getItem("aut");
            if (encryptedRole && this.$encryptBackoffice && this.$encryptBackoffice.decrypt) {
                return this.$encryptBackoffice.decrypt(encryptedRole);
            }
            return null;
        }
    }
}
</script>

<style scoped>
/* Estadísticas principales */
.stats-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

.stat-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 15px;
    padding: 1.5rem;
    color: white;
    display: flex;
    align-items: center;
    gap: 1rem;
    box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 35px rgba(102, 126, 234, 0.4);
}

.stat-card.secondary {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    box-shadow: 0 8px 25px rgba(240, 147, 251, 0.3);
}

.stat-card.secondary:hover {
    box-shadow: 0 12px 35px rgba(240, 147, 251, 0.4);
}

.stat-icon {
    font-size: 2rem;
    opacity: 0.9;
}

.stat-content {
    flex: 1;
}

.stat-number {
    font-size: 1.8rem;
    font-weight: bold;
    line-height: 1;
}

.stat-label {
    font-size: 0.9rem;
    opacity: 0.9;
    margin-top: 0.25rem;
}

/* Información de actualización */
.update-info {
    background: linear-gradient(135deg, #a8edea 0%, #fed6e3 100%);
    border-radius: 15px;
    padding: 1.5rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.update-header {
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 0.5rem;
}

.update-time {
    color: #34495e;
    font-weight: 500;
    font-size: 0.95rem;
}

/* Timeline de fechas */
.timeline-container {
    background: white;
    border-radius: 15px;
    padding: 1.5rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.timeline-header {
    color: #2c3e50;
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #ecf0f1;
}

.timeline {
    position: relative;
    max-height: 300px;
    overflow-y: auto;
}

.timeline-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 1.5rem;
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 0.5rem;
    border-radius: 10px;
}

.timeline-item:hover {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    transform: translateX(5px);
}

.timeline-marker {
    position: relative;
    margin-right: 1rem;
    flex-shrink: 0;
}

.marker-dot {
    width: 12px;
    height: 12px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 50%;
    border: 3px solid white;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.marker-line {
    position: absolute;
    left: 50%;
    top: 12px;
    width: 2px;
    height: calc(100% + 1.5rem);
    background: linear-gradient(to bottom, #667eea, #764ba2);
    transform: translateX(-50%);
}

.timeline-content {
    flex: 1;
    min-width: 0;
}

.timeline-date {
    font-weight: bold;
    color: #2c3e50;
    font-size: 0.95rem;
    margin-bottom: 0.25rem;
}

.timeline-time {
    color: #7f8c8d;
    font-size: 0.85rem;
    margin-bottom: 0.25rem;
}

.timeline-number {
    color: #667eea;
    font-size: 0.8rem;
    font-weight: 500;
}

.empty-timeline {
    text-align: center;
    color: #7f8c8d;
    padding: 2rem 1rem;
}

.empty-timeline i {
    font-size: 2rem;
    margin-bottom: 1rem;
    opacity: 0.5;
}

.empty-timeline p {
    margin: 0;
    font-size: 0.9rem;
}

/* Scrollbar personalizado */
.timeline::-webkit-scrollbar {
    width: 6px;
}

.timeline::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.timeline::-webkit-scrollbar-thumb {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 3px;
}

.timeline::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
}

/* Responsive */
@media (max-width: 768px) {
    .stats-container {
        grid-template-columns: 1fr;
    }

    .stat-card {
        padding: 1rem;
    }

    .stat-number {
        font-size: 1.5rem;
    }
}

/* Contenedor de carga */
.loading-container {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 15px;
    padding: 3rem 2rem;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    border: 2px dashed #dee2e6;
}

.loading-container .spinner-border {
    border-width: 0.25em;
}

.loading-container h5 {
    margin-bottom: 0.5rem;
    font-weight: 600;
}

.loading-container p {
    margin-bottom: 0;
    font-size: 0.95rem;
}
</style>